import { Text } from "@spawn/core";
import { TextStyles } from "./textStyles";

/**
 * Splits the given `text` into segments and creates a `Text` for each. The `highlighted`
 * text is styled in highlighted format.
 */
export function createTextHighlightSegments(
	text: string,
	highlight: string,
	createHighlight: (text: string) => Text = (value) => TextStyles.gold(value)
): { segments: Text[]; typeOfFirstWord: "gold" | "default" } {
	let typeOfFirstWord: "gold" | "default" = "default";

	// Check if the text starts with the highlight word
	if (text.startsWith(highlight)) {
		typeOfFirstWord = "gold";
		return {
			segments: [createHighlight(highlight), TextStyles.default(text.replace(highlight, "").trim())],
			typeOfFirstWord,
		};
	} else {
		return {
			segments: [TextStyles.default(text.replace(highlight, "").trim()), createHighlight(highlight)],
			typeOfFirstWord,
		};
	}
}
